export const messages = {
  en: {
    addReserveService: {
      title: 'Add Service',
      name: 'Name',
      namePlaceholder: 'Required, please enter name',
      nameRequired: 'Name is required',
      brand: 'Brand',
      brandPlaceholder: 'Please select brand',
      brandRequired: 'Brand cannot be empty',
      params: 'Parameters',
      paramsPlaceholder: 'Required, please select parameters',
      paramsRequired: 'Parameters is required',
      price: 'Service Fee',
      pricePlaceholder: 'Required, please enter service fee',
      priceRequired: 'Service fee is required',
      sort: 'Sort',
      sortPlaceholder: 'Required, please enter sort order',
      sortRequired: 'Sort order is required',
      startDate: 'Start Date',
      startDatePlaceholder: 'Required, please select start date',
      startDateRequired: 'Start date is required',
      endDate: 'End Date',
      endDatePlaceholder: 'Required, please select end date',
      endDateRequired: 'End date is required',
      coverImage: 'Service Cover',
      coverImageRequired: 'Service cover is required',
      state: 'Status',
      statePlaceholder: 'Required, please select status',
      stateRequired: 'Status is required',
      stateOff: 'Off Shelf',
      stateOn: 'On Shelf',
      goodsDesc: 'Service Description',
      goodsDescPlaceholder: 'Required, please enter service description',
      goodsDescRequired: 'Service description is required',
      content: 'Service Details',
      saveSuccess: 'Service saved successfully',
      saveFailed: 'Failed to save service'
    },
    uploadImage: {
      fileSizeLimit: 'Image size cannot exceed 2MB',
      uploadFailed: 'Image upload failed'
    }
  },
  zh: {
    addReserveService: {
      title: '添加服务',
      name: '名称',
      namePlaceholder: '必填，请填写名称',
      nameRequired: '名称不能为空',
      brand: '品牌',
      brandPlaceholder: '请选择品牌',
      brandRequired: '品牌不能为空',
      params: '参数',
      paramsPlaceholder: '必填，请选择参数',
      paramsRequired: '参数不能为空',
      price: '上门费',
      pricePlaceholder: '必填，请填写上门费',
      priceRequired: '上门费不能为空',
      sort: '排序',
      sortPlaceholder: '必填，请填写排序',
      sortRequired: '排序不能为空',
      startDate: '开始时间',
      startDatePlaceholder: '必填，请填写开始时间',
      startDateRequired: '开始时间不能为空',
      endDate: '结束时间',
      endDatePlaceholder: '必填，请填写结束时间',
      endDateRequired: '结束时间不能为空',
      coverImage: '服务封面',
      coverImageRequired: '服务封面不能为空',
      state: '状态',
      statePlaceholder: '必填，请选择状态',
      stateRequired: '状态不能为空',
      stateOff: '未上架',
      stateOn: '上架',
      goodsDesc: '商品简介',
      goodsDescPlaceholder: '必填，请填写商品简介',
      goodsDescRequired: '商品简介不能为空',
      content: '商品详情',
      saveSuccess: '服务保存成功',
      saveFailed: '服务保存失败'
    },
    uploadImage: {
      fileSizeLimit: '图片大小不能超过2MB',
      uploadFailed: '图片上传失败'
    }
  }
}